import React from "react";

function signalLabel(strength) {
  if (strength >= 4) return "Strong";
  if (strength >= 3) return "Good";
  if (strength >= 2) return "Weak";
  if (strength >= 1) return "Poor";
  return "Searching";
}

export default function GpsSignalIndicator({ telemetry, onCenter }) {
  const strength = telemetry?.signalStrength || 0;
  const isEstimated = !!telemetry?.isEstimated;
  const label = isEstimated ? "Estimated location" : telemetry ? `GPS ${signalLabel(strength)}` : "GPS pending";
  const detail = telemetry?.accuracy ? `±${Math.round(telemetry.accuracy)}m` : "Waiting for fix";

  return (
    <button
      type="button"
      onClick={onCenter}
      title="Center map on GPS location"
      aria-label="Center map on GPS location"
      className="absolute right-3 top-3 z-[950] rounded-2xl border border-white/25 bg-slate-950/90 px-2.5 py-2 text-left text-white shadow-xl shadow-black/25 backdrop-blur-xl transition hover:bg-slate-900 focus-visible:ring-2 focus-visible:ring-cyan-300 dark:border-cyan-100/20 dark:bg-slate-950/95 md:right-5 md:px-3"
    >
      <div className="flex items-center gap-2">
        <div className="flex items-end gap-0.5">
          {[1, 2, 3, 4].map((bar) => (
            <span
              key={bar}
              className={`${bar <= strength ? (isEstimated ? "bg-amber-300" : "bg-emerald-300") : "bg-white/20"} w-1 rounded-full`}
              style={{ height: `${bar * 3 + 5}px` }}
            />
          ))}
        </div>
        <div>
          <p className="text-[9px] font-black uppercase leading-none tracking-[0.12em]">GPS</p>
          <p className="mt-0.5 text-[10px] font-bold leading-none text-white/70">{detail}</p>
        </div>
      </div>
    </button>
  );
}